export default __webpack_public_path__ + "static/media/no_address.3b553626.svg";